<div class='list-wrapper' *ngIf='$relatedArticles()'>
  <p>Related articles from {{ provider.companyName }}</p>
  <app-related-article-item
    *ngFor='let relatedArticle of $relatedArticles()'
    [relatedArticle]='relatedArticle'
  ></app-related-article-item>
</div>
